<template>
  <div class="container-fluid">
    <div class="box box-info">
      <div class="box-header with-border">
        <h2>Pendências de Franquia pelo Fornecedor</h2>
      </div>
    </div>
    <div class="box-body" v-if="franquias.length != 0">
        <div class="row" v-for="franquia in franquias" :key="franquia.total">
          <div class="form-group col-xs-12 col-sm-4 col-md-8">
            <!-- <label for="inputEmail3" class="col-sm-6 control-label">{{ franquia.mes_ano }}: {{ franquia.total}} - {{ formatarMoeda(franquia.valor_total) }}</label> -->
            <div class="col-sm-3 control-label">{{ franquia.trimestre_ano }}</div>
            <div class="col-sm-3 control-label">{{ formatarMoeda(franquia.valor_total) }}</div>
            <div class="col-sm-3 control-label">{{ franquia.total_unidades}} unidades</div>
            <div class="col-sm-3">
              <b-button variant="primary" @click="glosar(franquia.meses, franquia.trimestre, franquia.ano)" :disabled="loading">
                {{ loadingTrimestre == franquia.trimestre ? 'aguarde...' : 'Glosar'}}
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="box-body" v-else>
        <h4 class="text-center">Não há pendências</h4>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      franquias: [],
      anos: [],
      ano_selecionado: new Date().getFullYear(),
      uf_selecionada: null,
      contrato_selecionado: null,
      mes: [],
      meses: [],
      tipo_imovel_servicos: '',
      env: process.env,
      estado: this.$store.state.login.loginUsuario.estado,
      ufs: [],
      ufId: [],
      gruposPermitidos: ['oi', 'admin'],
      permissao: true,
      loading: true,
      loadingTrimestre: null,
      dadosFechamento: [],
      mesSelecionado: null,
      janelaAplicacao: null
    }
  },
  mounted: function () {
    this.getFranquias()
  },
  methods: {
    glosar(meses, trimestre, ano) {
      let vm = this
      vm.loading = true
      vm.loadingTrimestre = trimestre
      let form = {
        meses: JSON.parse(meses),
        ano: ano,
        user_id: vm.$store.state.login.loginUsuario.usuario.id
      }
      vm.$axios.post(`${vm.env.FINANCEIRO.SLA}/glosarFranquiasNaoTratadas`, form, {
        headers: {
          'Authorization': `Bearer ${vm.$store.state.login.loginUsuario.token}`,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        vm.$store.commit('setAlert', { msg: `${response.data.total_afetadas} franquia(s) glosadas.`, status: true, show: true })
        vm.loading = true
        vm.loadingTrimestre = null
        vm.getFranquias()
      })
    },
    getFranquias() {
      let vm = this
      vm.loading = true
      vm.$axios.get(`${vm.env.FINANCEIRO.SLA}/get-franquias-pendentes-fornecedor`, {
        headers: {
          'Authorization': `Bearer ${vm.$store.state.login.loginUsuario.token}`
        }
      })
        .then(function (response) {
          vm.franquias = response.data
          console.log(response.data)
          vm.loading = false
        })
        .catch(function (error) {
          vm.loading = true
          vm.$store.commit('setAlert', { msg: 'Falha ao tentar carregar a janela de aplicação do ExtraContratual', status: false, show: true })
        })
    },
    formatarMoeda(valor) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(valor)
    }
  }
}
</script>

<style scoped>
.box-title,
.control-label {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// AplicarGlosaFranquias.vue?2fc0000d